module.exports = __webpack_public_path__ + "teqbahn-assets/media/34.071d223c.png";